export default __webpack_public_path__ + "static/shrek-c7336b79bea9915ecfe97e7c1c2ae0f5.webp";